var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.$t("请配置面板"),
      visible: _vm.visible,
      width: 600
    },
    on: {
      cancel: function ($event) {
        return _vm.$emit("cancel");
      },
      ok: _vm.handleSure
    }
  }, [_c("a-form-model", {
    ref: "dataFormRef",
    attrs: {
      model: _vm.formData,
      rules: _vm.formFules,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("展现形式"),
      prop: "showForm"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("展现形式")
    },
    model: {
      value: _vm.formData.showForm,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "showForm", $$v);
      },
      expression: "formData.showForm"
    }
  }, _vm._l(_vm.showList, function (item) {
    return _c("a-select-option", {
      key: item.key,
      attrs: {
        value: item.key
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1)], 1), _vm.dictionaryShow ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("字典选择"),
      prop: "dictionariesId"
    }
  }, _vm._l(_vm.dictionaryList, function (item, index) {
    return _c("div", {
      key: index
    }, [_c("div", {
      style: {
        borderBottom: "1px solid #E9E9E9",
        fontWeight: "bold"
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item.dictionaryType)) + " ")]), _vm._l(item.children, function (item2, index2) {
      return _c("a-checkbox", {
        key: index2,
        attrs: {
          checked: item2.checked
        },
        on: {
          change: e => _vm.onChange(e, index, index2)
        }
      }, [_vm._v(" " + _vm._s(_vm.$t(item2.label)) + " ")]);
    })], 2);
  }), 0) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };